import React, { useState, useEffect } from 'react'
import { Checkbox, Flex, Input, Select, Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import useToast from '../../../../hook/useToast';
import { removeVietnameseAccents } from '../../../../services/mixin'
import './DataSetupItem.scss'

interface Props {
  fileName?: string
  itemFile?: any
  columns?: any,
  source?: any,
  colChange?: (data: any) => void
  setShowParamModal?: (data: any) => void
}

const excelIcon = <svg width="1em" height="1.042em" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clipPath="url(#clip0_15514_69625)"> <path fillRule="evenodd" clipRule="evenodd" d="M6.14449 0.5H14.1766L20.9737 7.59489V21.373C20.9737 23.0985 19.581 24.5 17.8554 24.5H6.14449C4.4277 24.5 3.02625 23.0985 3.02625 21.373V3.61824C3.02621 1.90145 4.4277 0.5 6.14449 0.5Z" fill="#00733B" /> <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M14.1678 0.5V7.53358H20.9737L14.1678 0.5Z" fill="white" /> <path d="M10.489 17.9744H9.32403L8.52697 16.6343L7.72987 17.9744H6.55615L7.94011 15.6445L6.7226 13.6211H7.89629L8.52694 14.6722L9.14882 13.6211H10.3225L9.11376 15.6533L10.489 17.9744ZM10.9007 17.9744V13.6211H12.0131V17.0284H13.905V17.9744H10.9007V17.9744ZM15.7445 18.027C15.3065 18.027 14.9211 17.8868 14.5883 17.6153C14.2642 17.3525 14.0802 17.0197 14.054 16.6255L15.0087 16.3452C15.035 16.5555 15.1226 16.7394 15.2715 16.8796C15.4291 17.0197 15.6043 17.0898 15.797 17.0898C15.9547 17.0898 16.0861 17.0547 16.1912 16.9847C16.2875 16.9146 16.3401 16.8182 16.3401 16.7044C16.3401 16.608 16.2963 16.5292 16.2175 16.4591C16.1386 16.3978 16.0335 16.3452 15.9109 16.3015C15.7882 16.2577 15.6394 16.2139 15.4904 16.1788C15.3328 16.135 15.1751 16.0825 15.0262 16.0124C14.8685 15.9511 14.7284 15.8723 14.6058 15.7759C14.4744 15.6883 14.378 15.5569 14.2992 15.3905C14.2203 15.2328 14.1766 15.0401 14.1766 14.8212C14.1766 14.462 14.3254 14.1642 14.632 13.9277C14.9386 13.6825 15.3065 13.5686 15.7357 13.5686C16.1649 13.5686 16.5415 13.6737 16.8568 13.8752C17.1722 14.0854 17.3736 14.3569 17.4525 14.6898L16.4539 15.1102C16.4101 14.9263 16.3225 14.7774 16.1999 14.6635C16.0773 14.5584 15.9196 14.4971 15.7357 14.4971C15.5955 14.4971 15.4904 14.5321 15.4028 14.5847C15.324 14.6372 15.289 14.7161 15.289 14.8124C15.289 14.9 15.3415 14.9788 15.4466 15.0402C15.5517 15.0927 15.6919 15.1365 15.8495 15.1628C16.0072 15.1891 16.1824 15.2329 16.3663 15.2942C16.559 15.3643 16.7254 15.4343 16.8919 15.5307C17.0495 15.6183 17.1809 15.7672 17.286 15.9599C17.3999 16.1614 17.4524 16.3979 17.4524 16.6694C17.4524 17.0723 17.2948 17.4052 16.9794 17.6504C16.6641 17.8956 16.2525 18.027 15.7445 18.027Z" fill="white" /> </g> <defs> <clipPath id="clip0_15514_69625"> <rect width="24" height="24" fill="white" transform="translate(0 0.5)" /> </clipPath> </defs> </svg>

const DataSetupItem: React.FC<Props> = (props) => {
  const { fileName, itemFile, columns, colChange, source, setShowParamModal } = props
  const pushToast = useToast();
  const [options, setOptions] = useState([] as any)
  useEffect(() => {
    const temp = [] as any
    if (itemFile.source) {
      columns.map((x: any) => {
        if (x.source_id.includes(itemFile.source)) {
          temp.push({
            value: x.column,
            label: x.name,
          })
        }
      })
    } else {
      columns.map((x: any) => {
        temp.push({
          value: x.column,
          label: x.name,
        })
      })
    }

    setOptions([...temp])
    const ar = [] as any
    Object.keys(itemFile.obhead).map((val: any, index) => {
      if (itemFile.obhead[val].newField) {
        ar.push(itemFile.obhead[val].newField)
      }
    })
    setSelectedValues([...ar])
  }, [itemFile.source, columns])
  const [selectedValues, setSelectedValues] = useState([] as any); // Theo dõi giá trị cho 3 Select
  const handleChange = (value: any, valueOld: any) => {
    let temp = [...selectedValues] as any
    if (value) {
      if (value && valueOld) {
        temp = temp.filter((x: any) => x !== valueOld)
        temp.push(value)
      } else {
        temp.push(value)
      }
    } else {
      temp = temp.filter((x: any) => x !== valueOld)
    }
    setSelectedValues(temp)
    // const updatedValues = [...selectedValues]
    // updatedValues[index] = value
    // setSelectedValues(updatedValues)
  }
  const getFilteredOptions = (val: number) => {
    // const otherSelectedValues = selectedValues.filter((_: any, i: any) => i !== index)
    return options.filter((x: any) => selectedValues.includes(x.value) === false || x.value === val)
  }
  const getNameSource = () => {
    let res = 'Hệ thống...'
    try {
      res = source.find((x: any) => x.id === itemFile.source).name
    } catch (error) {
      res = 'Hệ thống...'
    }
    return res
  }
  return (
    <div className="data-setup-item">
      <div className="file-detail">
        {excelIcon}
        <span>{fileName}</span>
      </div>
      <Flex style={{ width: '100%' }} align='center' justify='space-between' className='gap-12px'>
        <Flex align='center' className='gap-12px'>
          <span className='no-wrap'>Thiết lập hệ thống</span>
          <Select
            value={itemFile.source}
            placeholder="Chọn hệ thống"
            options={source ? source.map((val: any) => ({ label: val.name, value: val.id })) : []}
            className="rs-select w-150-v2 rs-select--auto"

            allowClear
            onChange={(e) => {
              if (colChange) {
                colChange({ fileName, e, type: 1 })
              }
            }}
          />
        </Flex>
        <div>
          <Button
            icon={<PlusOutlined />}
            type="primary"
            className="rs-button primary-outline mie-auto"
            onClick={() => {
              if (setShowParamModal) {
                setShowParamModal({ fileName, source: itemFile.source })
              }
            }}
          >Tạo param mới</Button>
        </div>
      </Flex>

      {/* <Flex align='center' className='gap-12px'>
        <Checkbox
          className="rs-checkbox text-nowrap transparent"
        >Lưu thiết lập này</Checkbox>
        <Input
          placeholder="Nhập tên"
          className="rs-input w-210"
        />
      </Flex> */}

      <div className="preview-table">
        <div className="preview-table__head">
          <div className="preview-table__item preview-table__item-head">
            <div className="item">Dữ liệu trong tệp nhập liệu</div>
            <div className="item">Giá trị dòng thứ nhất trên tệp</div>
            {/* <div className="item text-end">{getNameSource()}</div> */}
            <div className="item text-end"></div>
          </div>
        </div>
        <div className="preview-table__body">
          {itemFile.headers.map((val: any, index: any) => (
            <div className="preview-table__item" key={val}>
              <div className="item"><span className="font-medium">{val}</span></div>
              <div className="item">{itemFile.firstRowData[val]}</div>
              <div className={`item`}>
                <Select
                  placeholder="Chọn 1 giá trị"
                  value={itemFile.obhead[val].newField}
                  options={getFilteredOptions(itemFile.obhead[val].newField)}
                  className="rs-select"

                  showSearch
                  optionFilterProp="label"
                  onChange={(e) => {
                    handleChange(e, itemFile.obhead[val].newField)
                    if (colChange) {
                      colChange({ fileName, val, e })
                    }
                  }}
                  allowClear
                  filterOption={(input, option) => {
                    const label = option?.label?.toString()?.toLowerCase() || '';
                    const searchText = input.toLowerCase();
                    return removeVietnameseAccents(label).includes(removeVietnameseAccents(searchText));
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default DataSetupItem
